import { useEffect, useState } from "react";
import { PartLookupComponentType } from "../../../types/part-lookup.type";
import { DeleteKeys, getTableHeaders, groupData } from "../../../utils/table.util";
import { KeysToRemoveFromPoints, PointsTableHeaders } from "../../../constants/partLookup.constants";
import { HeaderType } from "../../../types/table-view.type";
import { Table } from "@weirgroup/weir-dls";
import "../styles.scss";
import { useTranslation } from "react-i18next";

interface Props {
    points: PartLookupComponentType[],
    darkMode?: boolean
}

export const PointsTable = (props: Props) => {
    const { points } = props;
    const rowCount = 20;
    const [tableHeaders, setTableHeaders] = useState<HeaderType[]>([])
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pagedData, setPagedData] = useState<PartLookupComponentType[]>([]);

    const { t } = useTranslation();

    useEffect(() => {
        const headers = getTableHeaders(PointsTableHeaders)
        if (headers.length > 0) {
            setTableHeaders(headers);
        }
    }, [])

    const renameKeys = (obj: any, newKeys: any) => {
        const keyValues = Object.keys(obj).map(key => {
            const newKey = newKeys[key] || key;
            return { [newKey]: obj[key] };
        });
        return Object.assign({}, ...keyValues);
    }

    useEffect(() => {
        const filteredData = DeleteKeys(points, KeysToRemoveFromPoints)
        const newKeys = { component_item: "part_number" }
        const updatedData: any = []
        console.log(points)
        filteredData.forEach((data: any) => updatedData.push(renameKeys(data, newKeys)))
        setPagedData(groupData(updatedData, rowCount))
    }, [points, rowCount]);
    return (
        <div className="points">
            {(pagedData?.length > 0) && (tableHeaders?.length > 0) ?
                    <Table
                        darkMode={props.darkMode}
                        header={tableHeaders}
                        source={pagedData[currentPage - 1]}
                        title={t("componentTitle")}
                        canvasDeviceSize={'desktop'}
                        tableType={'default'}
                        pagination
                        onPageChange={(page: number) => {
                            setCurrentPage(page);
                        }}
                        currentPage={currentPage}
                        maxPages={pagedData?.length}
                    />
                : <></>}
        </div>
    )
}